import React from 'react';
import DecisionVoucherV2Page from './DecisionVoucherV2Page';
import useCurrentSav from '../../../../Hooks/useCurrentSav';
/**
 * Point d'entrée principal pour la nouvelle interface V2 du bon pour accord/refus
 */
const VoucherV2Flow: React.FC = () => {

  const { sav } = useCurrentSav();
  const savId = sav?.id;
  return (
    <div className="tw-w-full tw-h-full">
      <DecisionVoucherV2Page savId={savId} />
    </div>
  );
};

export default VoucherV2Flow;